const ADMIRAL_HATS = [
  {
    slug: "admiral-blue-31",
    name: "Admiral",
    description: "When one ship isn't enough",
    rarity: "epic",
    slot: "hat",
    shopCategory: "hat",
    statChanges: [
      {
        stat: "blueColor",
        value: 35
      },
      {
        stat: "blueRes",
        value: 15
      },
      {
        stat: "goldColor",
        value: 10
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_blue",
      frameIndex: 31
    },
    tags: ["daily-rotation"]
  },
  {
    slug: "admiral-green-31",
    name: "Admiral",
    description: "When one ship isn't enough",
    rarity: "epic",
    slot: "hat",
    shopCategory: "hat",
    statChanges: [
      {
        stat: "greenColor",
        value: 35
      },
      {
        stat: "greenRes",
        value: 15
      },
      {
        stat: "blueColor",
        value: 10
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_green",
      frameIndex: 31
    },
    tags: ["daily-rotation"]
  },
  {
    slug: "admiral-orange-31",
    name: "Admiral",
    description: "When one ship isn't enough",
    rarity: "epic",
    slot: "hat",
    shopCategory: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 35
      },
      {
        stat: "greenRes",
        value: 15
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_orange",
      frameIndex: 31
    },
    tags: ["daily-rotation"]
  },
  {
    slug: "admiral-pink-31",
    name: "Admiral",
    description: "When one ship isn't enough",
    rarity: "epic",
    slot: "hat",
    shopCategory: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 35
      },
      {
        stat: "goldRes",
        value: 15
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_pink",
      frameIndex: 31
    },
    tags: ["daily-rotation"]
  },
  {
    slug: "admiral-red-31",
    name: "Admiral",
    description: "When one ship isn't enough",
    rarity: "epic",
    slot: "hat",
    shopCategory: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 35
      },
      {
        stat: "redRes",
        value: 15
      },
      {
        stat: "blackColor",
        value: 10
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_red",
      frameIndex: 31
    },
    tags: ["daily-rotation"]
  }
];
export {
  ADMIRAL_HATS
};
//# sourceMappingURL=data:application/json;base64,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
